import { useEffect } from "react";
import { useState } from "react";
import { constSelector, useRecoilState } from "recoil";
import useExamRoomActions from "../../../../api/hooks/admin/examRoom";
import { isSendMailModalOpenState } from "../../../../recoil/admin/examRoom";
import Modal from "../../../modules/layout/Modal";
import { useMutation } from "@tanstack/react-query";

const SendMailModal = ({ mailUserSn, emailCheckData }) => {
  const examRoomActions = useExamRoomActions();
  const [mailInfo, setMailInfo] = useState({});
  const [isSendMailModalOpen, setIsSendMailModalOpen] = useRecoilState(
    isSendMailModalOpenState
  );

  useEffect(() => {
    if (mailUserSn) {
      checkEmail(mailUserSn);
    }
  }, [mailUserSn]);

  const checkEmail = (user_sn) => {
    if (user_sn) {
      mutation.mutate({ applicator_sn: user_sn, sendType: 1 });
    }
  };

  const mutation = useMutation(examRoomActions.checkEmail, {
    onSuccess: (context) => {
      setMailInfo(context.data);
      if (context?.status === 200) {
        setIsSendMailModalOpen(true);
      } else {
        alert("유저를 찾을 수 없습니다.");
      }
    },
    onError: () => {
      alert("실패.");
    },
  });

  return (
    <Modal isOpen={isSendMailModalOpen}>
      <div className="modal fade" id="mail" style={{ display: "block" }}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header flex">
              <p className="sign-top-title" id="staticBackdropLabel">
                OPIC 시험코드
              </p>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={() => setIsSendMailModalOpen(false)}
              ></button>
            </div>
            <div className="modal-body confirm-sec">
              <div className="modal-title">
                <p>전송내용mail</p>
              </div>
              <div className="modal-cont">
                <div className="white-border-box">
                  <div
                    style={{ overflow: "scroll", height: 500 }}
                    dangerouslySetInnerHTML={{ __html: mailInfo?.content }}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* <div className="modal-footer text-align-right">
            <button
              type="button"
              className="modal-btn modal-close-btn"
              onClick={() => setIsSendMailModalOpen(false)}
            >
              닫기
            </button>
          </div> */}
        </div>
      </div>
    </Modal>
  );
};
export default SendMailModal;
